import { ApiService } from '@sparklayer-io/spark-dash-core/types/api';
import type { DiscountPriority } from '../lib/priorities';
import type { DiscountApiPayload } from '../transformers';
import type { Discount } from '../types';
import { DiscountApi, type DiscountApiContract } from './discount.api';

export interface DiscountsApiContract {
  discount(id: string): DiscountApiContract;

  list(): Promise<Discount[]>;
  create(discount: DiscountApiPayload): Promise<Discount>;
  setPriorities(priorities: DiscountPriority[]): Promise<void>;
}

declare module '@sparklayer-io/spark-dash-core/context/page-context' {
  interface Apis {
    discounts: DiscountsApiContract;
  }
}

export class DiscountsApi extends ApiService implements DiscountsApiContract {
  public discount(id: string): DiscountApiContract {
    return new DiscountApi(this.api, id);
  }

  public list(): Promise<Discount[]> {
    return this.api.proxy<Discount[]>({
      method: 'GET',
      path: '/v1/discounts',
      payload: {},
    });
  }

  public create(payload: DiscountApiPayload): Promise<Discount> {
    return this.api.proxy<Discount>({
      method: 'POST',
      path: '/v1/discounts',
      payload,
    });
  }

  public setPriorities(priorities: DiscountPriority[]): Promise<void> {
    return this.api.proxy({
      method: 'PATCH',
      path: '/v1/set-discount-priorities',
      payload: priorities,
    });
  }
}
